export default __webpack_public_path__ + "media/projects/red3-36f5e917.svg";